import { useMatch } from 'react-router';
import useIsIbDeskAvailable from './useIsIbDeskAvailable';

export const IB_DESK_PATH = '/ib-data';
export const IB_DESK_EMBED_PATH = '/embed/ib-desk';

// The router's own matcher keeps the provider's isEnabled in step with the "/ib-data/*" and "/embed/ib-desk/*" routes
export const useIsIbDeskRoute = (): boolean => {
  const isIbDeskPath = useMatch(`${IB_DESK_PATH}/*`) !== null;
  const isIbDeskEmbedPath = useMatch(`${IB_DESK_EMBED_PATH}/*`) !== null;

  return isIbDeskPath || isIbDeskEmbedPath;
};

// The gateway uses only useIsIbDeskRoute (membership lives inside the provider); the header uses this hook so that
// a non-IB user never sees the section header before the redirect
const useIbDeskSection = (): boolean => {
  const isIbDeskAvailable = useIsIbDeskAvailable();
  const isIbDeskRoute = useIsIbDeskRoute();

  return isIbDeskAvailable && isIbDeskRoute;
};

export default useIbDeskSection;
